export default __webpack_public_path__ + "static/media/Kanit-Regular.f3bae13d.ttf";